const STEPS = [
    {
        n: "01",
        title: "Diagnose",
        body: "Authority audit — narrative gaps, search/LLM presence, share of voice mapped against the AMEC framework.",
        meta: "Sprint 01",
    },
    {
        n: "02",
        title: "Architect",
        body: "Strategy thesis, narrative pillars, GEO co-citation roadmap, distribution & paid stack designed for your sales cycle.",
        meta: "Sprint 02",
    },
    {
        n: "03",
        title: "Activate",
        body: "Cinematic production, editorial validation, journalist outreach with the Producer's Kit, performance buys go live.",
        meta: "Sprint 03",
    },
    {
        n: "04",
        title: "Amplify",
        body: "Synergetic loop: every win recycled into editorial assets, performance creative, and additional GEO surface area.",
        meta: "Sprint 04",
    },
    {
        n: "05",
        title: "Audit",
        body: "Quarterly reputation index, board-ready ROI report, and the next thesis. Authority is a system, not a campaign.",
        meta: "Sprint 05+",
    },
];

export default function Process() {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="relative py-28 md:py-36"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-12 gap-10 mb-16 reveal">
                    <div className="md:col-span-7">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-[#e6192b] mb-5">
                            ⎯⎯ §05 · The Roadmap
                        </div>
                        <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
                            Roadmap to{" "}
                            <span className="italic">Authority</span>.
                        </h2>
                    </div>
                    <p className="md:col-span-5 text-[#a0a0ab] leading-relaxed self-end">
                        A five-stage operating system. Linear in cadence,
                        cyclical in compounding. Designed to behave like an
                        external media department from week one.
                    </p>
                </div>

                <ol className="relative border-t border-[#26262a]">
                    {STEPS.map(({ n, title, body, meta }, i) => (
                        <li
                            key={n}
                            data-testid={`process-step-${i}`}
                            className="grid grid-cols-12 gap-6 py-10 md:py-12 border-b border-[#26262a] group hover:bg-[#0a0a0c] transition-colors duration-500 reveal"
                            style={{ transitionDelay: `${i * 60}ms` }}
                        >
                            <div className="col-span-3 md:col-span-2 font-serif-display italic text-5xl md:text-7xl text-[#26262a] group-hover:text-[#e6192b] transition-colors duration-500 tabular-nums leading-none">
                                {n}
                            </div>
                            <div className="col-span-9 md:col-span-7">
                                <h3 className="font-serif-display text-3xl md:text-4xl mb-3">
                                    {title}
                                </h3>
                                <p className="text-[#a0a0ab] leading-relaxed max-w-2xl">
                                    {body}
                                </p>
                            </div>
                            <div className="col-span-12 md:col-span-3 flex md:justify-end items-start">
                                <span className="text-[11px] uppercase tracking-[0.22em] text-[#5a5a63] group-hover:text-white transition-colors">
                                    {meta}
                                </span>
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
